import { requestJson } from "./apiClient";

export async function fetchAdminLeadBrokerConfig() {
  return requestJson("/api/admin/lead-broker/config");
}

export async function patchAdminLeadBrokerConfig(payload) {
  return requestJson("/api/admin/lead-broker/config", {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
}

export async function testAdminLeadBrokerConnection() {
  return requestJson("/api/admin/lead-broker/config/test-connection", {
    method: "POST",
  });
}
